import {
  routeINV,
  routeCN,
  routePO,
  routeBCN,
  routeBL,
  routeTR,
  routeAJ,
  routeInfoPRDC,
  routeInfoCSR,
  routeInfoSPL,
  routeInfoWH,
  routeInfoBRD,
  routeInfoEMPL
} from '../router'

export default {
  namespaced: true,
  state: {
    orderTypeIcons: [
      { type: 1, icon: 'table-cell-sheet-type-icon-inv' },
      { type: 2, icon: 'table-cell-sheet-type-icon-cn' },
      { type: 3, icon: 'table-cell-sheet-type-icon-po' },
      { type: 4, icon: 'table-cell-sheet-type-icon-inv' },
      { type: 5, icon: 'table-cell-sheet-type-icon-cn' }
    ],
    status: [
      { status: 'Draft', class: 'table-cell-status-style-Draft' },
      { status: 'Approved', class: 'table-cell-status-style-approved' },
      { status: 'Voided', class: 'table-cell-status-style-Voided' }
    ],
    closed: [
      { status: 'Closed', class: 'table-cell-status-style-printed' },
      { status: 'Unclosed', class: 'table-cell-status-style-unprinted' }
    ],
    sendXero: [
      { status: 'Unsent', class: 'table-cell-status-style-xerounsent' },
      { status: 'Fail', class: 'table-cell-status-style-xerounsent' },
      { status: 'SENT', class: 'table-cell-status-style-xerosent' }
    ],
    print: [
      { status: 'UnPrint', class: 'table-cell-status-style-unprinted' },
      { status: 'PRINT', class: 'table-cell-status-style-printed' }
    ],
    pageTitle: [
      { name: 'Quotings', title: 'Quoting' },
      { name: 'Ocops', title: 'OCOP Price' },
      { name: 'Invoice', title: 'Invoices' },
      { name: 'CreditNotes', title: 'Credit Notes' },
      { name: 'PurchaseOrders', title: 'Purchase Orders' },
      { name: 'Bills', title: 'Bills' },
      { name: 'BillCreditNotes', title: 'Bill Credit Notes' },
      { name: 'Transfers', title: 'Transfers' },
      { name: 'Adjustments', title: 'Adjustments' },
      { name: 'Products', title: 'Products' },
      { name: 'Customers', title: 'Customers' },
      { name: 'Suppliers', title: 'Suppliers' },
      { name: 'Warehouses', title: 'Warehouses' },
      { name: 'Brands', title: 'Brands' },
      { name: 'Employees', title: 'Employees' }
    ]
  },
  getters: {
    orderTypeIcon: state => type => {
      const icon = state.orderTypeIcons.find(item => item.type === type) || {
        icon: ''
      }
      return icon.icon
    },
    statusClass: state => status => {
      const css = state.status.find(item => item.status === status) || {
        class: ''
      }
      return css.class
    },
    closedClass: state => status => {
      const css = state.closed.find(item => item.status === status) || {
        class: ''
      }
      return css.class
    },
    xeroClass: state => status => {
      const css = state.sendXero.find(item => item.status === status) || {
        class: ''
      }
      return css.class
    },
    printClass: state => status => {
      const css = state.print.find(item => item.status === status) || {
        class: ''
      }
      return css.class
    },
    searchInvCellClass: (state, getters) => ({ row, column }) => {
      if (column.property === 'status') {
        return getters.statusClass(row.status)
      } else if (column.property === 'closure') {
        return getters.closedClass(row.closure)
      } else if (column.property === 'xeroSent') {
        return getters.xeroClass(row.xeroSent)
      } else if (column.property === 'print') {
        return getters.printClass(row.print)
      }
    },
    searchBgClass: () => routeName => {
      switch (routeName) {
        case routeCN:
        case routeBCN:
          return 'creditBgColor'
        case routePO:
          return 'pOrderBgColor'

        default:
          return 'bgColor'
      }
    },
    getPageTitle: state => routeName =>
      state.pageTitle.find(p => p.name === routeName).title,
    newBtnName: () => routeName => {
      switch (routeName) {
        case routeINV:
          return 'Invoice'
        case routeCN:
        case routeBCN:
          return 'Credit Note'
        case routePO:
          return 'Purchase Order'
        case routeBL:
          return 'Bill'
        case routeTR:
          return 'Transfer'
        case routeAJ:
          return 'Adjustment'
        case routeInfoPRDC:
          return 'Products'
        case routeInfoCSR:
          return 'Customers'
        case routeInfoSPL:
          return 'Suppliers'
        case routeInfoWH:
          return 'Warehouses'
        case routeInfoBRD:
          return 'Brands'
        case routeInfoEMPL:
          return 'Employees'
        default:
          return ''
      }
    },
    newBtnClass: () => routeName => {
      switch (routeName) {
        case routeINV:
        case routeBL:
        case routeTR:
        case routeAJ:
        case routeInfoPRDC:
        case routeInfoCSR:
        case routeInfoSPL:
        case routeInfoWH:
        case routeInfoBRD:
        case routeInfoEMPL:
          return 'btn'
        case routeCN:
        case routeBCN:
          return 'btn-secondary'
        case routePO:
          return 'btn-third'
        default:
          return ''
      }
    },
    showSearchCard: () => routeName => {
      switch (routeName) {
        case routeInfoSPL:
        case routeInfoWH:
        case routeInfoBRD:
        case routeInfoEMPL:
          return false
        default:
          return true
      }
    },
    footerMl: () => isEdit => (isEdit ? 0 : 7)
  }
}
